import ProfileAvatar from "components/ProfileAvatar";
import env from "config/env";
import { TicketDetails } from "features/types";
import React from "react";
import { View, ImageBackground } from "react-native";

interface BarcodeImageBackground {
  ticket: TicketDetails;
}
const BarcodeImageBackground: React.FC<BarcodeImageBackground> = ({
  ticket,
}) => {
  const { tenantType, tenantSubdomain, type } = ticket.event;
  const barcodeBackgroundSrc = `https://branding.fanrally.com/barcode_images/${tenantType}/${tenantSubdomain}/${type}/barcode.gif`;
  const userImageURL = (imageIdentifier: string) =>
    env.fileUrl.replace("tenantSubdomain", tenantSubdomain!) +
    `/${imageIdentifier}`;

  return (
    <ImageBackground
      source={{ uri: barcodeBackgroundSrc }}
      style={{
        justifyContent: "flex-end",
        alignItems: "flex-end",
        overflow: "hidden",
        minHeight: 75,
        padding: 4,
      }}
      resizeMode="cover"
    >
      <View>
        {ticket.user?.imageIdentifier ? (
          <ProfileAvatar
            hasImageIdentifier={ticket.user.imageIdentifier !== null}
            size={75}
            source={{ uri: userImageURL(ticket.user.imageIdentifier) }}
          ></ProfileAvatar>
        ) : (
          <View style={{ width: 75, height: 75 }} />
        )}
      </View>
    </ImageBackground>
  );
};

export default BarcodeImageBackground;
